export class HubSelectionItem {
  id: number;
  name: string;

  constructor(params?: HubSelectionItem) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
